import { render, staticRenderFns } from "./AccordionForModifyRecord.vue?vue&type=template&id=381a42d2&"
import script from "./AccordionForModifyRecord.vue?vue&type=script&lang=js&"
export * from "./AccordionForModifyRecord.vue?vue&type=script&lang=js&"
import style0 from "./AccordionForModifyRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports